<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
        elevation="0"
        class="all-trade-tab rounded-0"
      >
        <v-tabs
          :background-color="
            $vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'
          "
          v-model="model"
        >
          <v-tab class="ml-0" :href="`#tab-1`">
            Inactive Accounts
          </v-tab>
          <v-tab :href="`#tab-2`"> Low Balance Accounts </v-tab>
          
          <v-tabs-items v-model="model">
            <v-tab-item :value="`tab-1`">
              <v-card flat>
                <InactiveAccountsTab></InactiveAccountsTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-2`">
              <v-card flat>
                <LowBalanceAccountsTab></LowBalanceAccountsTab>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import InactiveAccountsTab from "./InactiveAccountsTab.vue";
import LowBalanceAccountsTab from "./LowBalanceAccountsTab.vue";
export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    InactiveAccountsTab,
    LowBalanceAccountsTab,
  },
};
</script>
